module.exports = __webpack_public_path__ + "img/A_stamp.4fa0bc5d.png";